import { render, staticRenderFns } from "./c_tab.vue?vue&type=template&id=164f6c58&scoped=true"
import script from "./c_tab.vue?vue&type=script&lang=js"
export * from "./c_tab.vue?vue&type=script&lang=js"
import style0 from "./c_tab.vue?vue&type=style&index=0&id=164f6c58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f6c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164f6c58')) {
      api.createRecord('164f6c58', component.options)
    } else {
      api.reload('164f6c58', component.options)
    }
    module.hot.accept("./c_tab.vue?vue&type=template&id=164f6c58&scoped=true", function () {
      api.rerender('164f6c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_tab.vue"
export default component.exports